module.exports = __webpack_public_path__ + "Roboto-Light.8f700b1b42f2d429d64e.woff2";


//////////////////
// WEBPACK FOOTER
// D:/V1/er.web.candidateconsole/src/assets/fonts/Roboto-Light.woff2
// module id = ../../../../../src/assets/fonts/Roboto-Light.woff2
// module chunks = styles